<template>
  <v-row class="mt-6 checkout-review-buttons">
    <v-col
      cols="6"
      md="5"
      class="return-to-catalog"
    >
      <tc-v-btn
        id="order-review-return-to-catalog-button"
        x-large
        class="text-capitalize pl-0"
        text
        color="primary"
        @click="$router.push({ name: catalogRoute })"
      >
        <v-icon
          x-large
          aria-hidden="true"
        >
          mdi-chevron-left
        </v-icon>
        {{ $t('checkoutReview.returnButton') }}
      </tc-v-btn>
    </v-col>
    <v-col
      cols="12"
      md="7"
      class="text-right"
    >
      <tc-v-btn
        id="order-review-proceed-button"
        color="accent"
        min-width="275"
        x-large
        :block="$vuetify.breakpoint.smAndDown"
        :loading="showLoading"
        :disabled="completeButtonIsDisabled"
        :loading-text="completeButtonText"
        @click="$emit('proceed')"
      >
        <span :class="{ 'text-capitalize px-0': $vuetify.breakpoint.xsOnly }">
          {{ completeButtonText }}
        </span>
      </tc-v-btn>
    </v-col>

    <tc-v-btn
      class="back-to-catalog-button"
      tabindex="0"
      color="accent"
      text
      @click="$router.push({ name: catalogRoute })"
      @keyup.enter.prevent="$router.push({ name: catalogRoute })"
    >
      <span class="text-capitalize">
        {{ $t('reward-back-to-catalog') }}
      </span>
    </tc-v-btn>
  </v-row>
</template>

<script>
import { CATALOG_ROUTE } from '@/router/routes/route-names'

export default {
  name: 'CheckoutReviewButtons',
  props: {
    completeButtonIsDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    completeButtonText: {
      type: String,
      required: true
    },
    showLoading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    catalogRoute () {
      return CATALOG_ROUTE
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';

.checkout-review-buttons {
  .btn-sm {
    padding: 18px 8px;
    background: #29a1b9;
    border-radius: 0;
    font-size: 16px;
    font-family: Gotham-Medium, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    margin-bottom: 20px;

    i.fa-2x {
      margin-top: -5px;
      line-height: 0.5em;
      vertical-align: middle;
    }
  }

  .bg-transparent {
    background-color: transparent !important;
  }

  .return-to-catalog {
    display: none;

    .checkout-review-back-button {
      display: flex;
      line-height: 42px;
      padding: 0;
    }
  }

  .back-to-catalog-button {
    margin-top: 38px;
    width: 100%;
    text-align: center;
  }
}

@media screen and (max-width: $breakpoint-lg - 1) {
  .btn-xs-block {
    margin-bottom: 15px;
    width: 100%;
  }
}

@media screen and (min-width: $breakpoint-md) {
  .checkout-review-buttons {
    .back-to-catalog-button {
      display: none;
    }
    .return-to-catalog {
      display: flex;
    }
  }
}
</style>
